export const availabilityStatuses = {
    AVAILABLE: 'available',
    UNAVAILABLE: 'unavailable',
};
